import React from 'react';
import { WaveCard } from './WaveCard';
import SafeIcon from '../common/SafeIcon';

export const ProductGrid = ({ id, title, subtitle, products }) => {
  return (
    <section id={id} className="py-20 bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h2 className="text-4xl font-black text-[#0a192f] mb-4 uppercase tracking-tight">{title}</h2>
          <div className="w-24 h-1 bg-[#ff7f50] mx-auto mb-6 rounded-full"></div>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">{subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {products.map((product) => (
            <WaveCard key={product.id} className="flex flex-col group">
              <div className="relative h-80 overflow-hidden bg-gray-100">
                {product.tag && (
                  <div className="absolute top-4 left-4 z-10 bg-[#93e9be] text-[#0a192f] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-sm">
                    {product.tag}
                  </div>
                )}
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                
                {/* Quick Add Overlay */}
                <div className="absolute inset-0 bg-[#0a192f]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <button className="bg-[#ff7f50] text-white px-6 py-3 rounded-full font-bold transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 flex items-center shadow-lg hover:bg-[#e66c3e]">
                    <SafeIcon name="Plus" className="mr-2 h-5 w-5" /> Quick Add
                  </button>
                </div>
              </div>
              
              <div className="p-8 flex flex-col flex-grow bg-white">
                <h3 className="text-xl font-bold text-[#0a192f] mb-2">{product.name}</h3>
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <SafeIcon key={i} name="Star" className="h-4 w-4 text-[#ff7f50] fill-current" />
                  ))}
                  <span className="text-xs text-gray-500 ml-2">(12)</span>
                </div>
                <div className="mt-auto flex items-center justify-between">
                  <span className="text-2xl font-black text-[#0a192f]">${product.price.toFixed(2)}</span>
                  <button className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-[#0a192f] hover:bg-[#93e9be] hover:text-[#0a192f] transition-colors">
                    <SafeIcon name="ShoppingCart" className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </WaveCard>
          ))}
        </div>
        
      </div>
    </section>
  );
};